import styled from 'styled-components/macro';
import theme from 'components/theme';
import Button from 'components/Button';
import { mediaDesktop } from 'breakpoints';

export const CollectionWrapper = styled.div`
  padding-bottom: 40px;

  ${mediaDesktop} {
    padding-bottom: 100px;
  }
`;

export const ButtonWrapper = styled.div`
  margin: auto;
  width: 100%;
  padding: 0 24px;
  max-width: 375px;

  ${mediaDesktop} {
    max-width: 332px;
  }

  ${Button} {
    padding: 8px 6px;
    font-size: 13px;
    border-width: 1px;

    ${mediaDesktop} {
      padding: 5px 6px;
      font-size: 16px;
    }
  }
`;

export const PopUpText = styled.div`
  font-family: ${theme.fonts.secondary};
  font-size: 30px;
  letter-spacing: 1px;
  font-weight: 600;
  text-align: center;
  padding-bottom: 50px;
`;

export const GroupBtn = styled(Button)`
  margin-bottom: 20px;
`;

export const ModalSuccessText = styled.p`
  font-family: ${theme.fonts.secondary};
  font-size: 30px;
  letter-spacing: 1px;
  text-align: center;
  font-weight: 600;
  padding-bottom: 40px;

  ${mediaDesktop} {
    padding-bottom: 50px;
  }
`;

export const CollectionSalesInfoWrapper = styled.div`
  margin-top: 23px;
  padding: 23px 20px 20px;
  ${mediaDesktop} {
    padding-top: 0;
    display: flex;
    justify-content: center;
  }
`;

export const LoaderContainer = styled.div`
  height: calc(100vh - 160px);

  ${mediaDesktop} {
    height: calc(100vh - 200px);
  }
`;
